import { Action } from '@ngrx/store';
import { ParameterModel } from "../../models/ParameterModel";
import { UpdateParametersModel } from "../../models/UpdateParametersModel";

export const GET_PARAMETERS_SUCCESS = '[Rule] Get Parameters Success';

export class GetParametersSuccessAction implements Action {
  readonly type = GET_PARAMETERS_SUCCESS;

  constructor(public payload: { updateParameterModel: UpdateParametersModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetParametersSuccessAction.ts